import { ErrorNotification } from '@gravitate-js/excalibrr'
import { Col, Form, Row } from 'antd'
import React, { useState } from 'react'

import { MetricDetail } from '../MetricDetail'
import { useFormatter } from '@api/useFormatter'

export function SpecialPayForm({ specialPay, setFormUpdated }) {
  const [editing, setEditing] = useState(false)
  const [form] = Form.useForm()

  form.setFieldsValue({ ...specialPay })

  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true)

  const handleSave = () => {
    // I don't think this function is ever called?
    setEditing(false)
    setFormUpdated(true)
    setFormUpdated(false)
  }

  return (
    <Form
      id='special-pay-form'
      form={form}
      onFinish={(formData) => {
        handleSave(formData)
      }}
      onFinishFailed={ErrorNotification}
    >
      <Row className='pay-row'>
        <Col className='pay-period-group special' span={8}>
          <div className='special-pay-flex p-3'>
            <Row className='special-pay pt-1'>
              <Col className='label pl-5' span={12} align='left'>
                <b>SPECIAL PAY</b>
              </Col>
              <Col span={12} align='center'>
                <b>
                  {formattedCurrency}
                  {specialPay.special_pay_total.toFixed(2)}
                </b>
              </Col>
            </Row>
          </div>
        </Col>
        <Col className='pay-period-row-column pt-2' span={16}>
          <Row>
            {specialPay.pay_items.map((detail, index) => (
              <MetricDetail
                key={index}
                detail={detail}
                form={form}
                count={specialPay.pay_items.length}
                index={index}
                editing={editing}
                metricClass='special metric'
                iconClass='special'
              />
            ))}
          </Row>
        </Col>
      </Row>
    </Form>
  )
}
